import { useOnboardingStore } from '~/stores/useOnboardingStore'

/**
 * Hydrate onboarding answers / completion flag from localStorage
 * before route middleware runs.
 */
export default defineNuxtPlugin(() => {
  const onboarding = useOnboardingStore()
  onboarding.hydrateFromStorage()
})
